import { makeAutoObservable, ObservableMap } from 'mobx';
import { IDType } from '../../models';
import type { RootStoreClass } from '../rootStore';
import TournamentTableStore from './tournament.tableStore';

export default class TournamentTableStores {
    stores = new ObservableMap<IDType, TournamentTableStore>();

    rootStore: RootStoreClass;

    constructor(rootStore: RootStoreClass) {
        this.rootStore = rootStore;

        makeAutoObservable(this);
    }

    setTable = (tournamentId: IDType) => {
        const store = new TournamentTableStore(this.rootStore, tournamentId);
        this.stores.set(tournamentId, store);
        return store;
    };

    getTable = (tournamentId?: IDType) => {
        if (!tournamentId) {
            return null;
        }

        if (this.stores.has(tournamentId)) {
            const store = this.stores.get(tournamentId);
            return store;
        }

        return this.setTable(tournamentId);
    };

    removeTable = (tournamentId: IDType) => {
        this.stores.delete(tournamentId);
    };

    clearStore = () => {
        this.stores = new ObservableMap();
    };
}
